<p
  [innerHTML]="sanitizeFunction(termin.angebot.inhalt)"
  id="detail_inhalte"
  class="anbieter_content"
></p>
@if (termin.bemerkung) {
  <ul class="p-0">
    <li class="d-flex flex-column mb-1">
      <span id="detail_bemerkung_label" class="fw-bold">Weitere Informationen</span>
      <span id="detail_bemerkung" [innerHTML]="sanitizeFunction(termin.bemerkung)"> </span>
    </li>
  </ul>
}
